/**
 * App 环境初始化默认配置
 */
export const defaultEnvOptions = {
	appTitleBar: false, // 是否显示标题栏
	platform: "web", // 平台类型
};
